import { fromJS } from 'immutable'
import {
  DEPARTMENT_EDIT_REQUEST,
  DEPARTMENT_EDIT_SUCCESS,
  DEPARTMENT_EDIT_FAILURE,
  DEPARTMENT_EDIT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case DEPARTMENT_EDIT_REQUEST:
      return state
        .set('isFetching', true)
    case DEPARTMENT_EDIT_SUCCESS:
      return state
        .set('departmentEdit', fromJS(action.payload.updatedDepartment))
        .set('status', 200)
        .set('message', 'Edited Successfully.')
        .set('isFetching', false)
    case DEPARTMENT_EDIT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('departmentEdit', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case DEPARTMENT_EDIT_RESET:
      return state
        .delete('departmentEdit')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/department/department-edit-reducer.js